const orderBy = require('lodash/orderBy')

const TAG_INSURANCE = 'Insurance'
const TAG_TAXES = 'Taxes'
const TAG_BUSINESS = 'Business'
const TAG_REAL_ESTATE = 'Real Estate'
const TAG_EMPLOYMENT = 'Employment'
const TAG_STUDENT_LOANS = 'Student loans'
const TAG_TRAVEL = 'Travel'
const TAG_FINANCE = 'Finance'
const TAG_HEALTHCARE = 'Healthcare'

module.exports = {
  TAG_INSURANCE,
  TAG_TAXES,
  TAG_BUSINESS,
  TAG_REAL_ESTATE,
  TAG_EMPLOYMENT,
  TAG_STUDENT_LOANS,
  TAG_TRAVEL,
  TAG_FINANCE,
  TAG_HEALTHCARE,
  // NOTE: this is temp. need to figure out 'prebuilt' content naming, but for now this helps
  // this should eventually also control the order on the index page
  default: orderBy(
    [
      TAG_INSURANCE,
      TAG_TAXES,
      TAG_BUSINESS,
      TAG_REAL_ESTATE,
      TAG_EMPLOYMENT,
      TAG_STUDENT_LOANS,
      TAG_TRAVEL,
      TAG_FINANCE,
      TAG_HEALTHCARE,
    ],
    [(tag) => tag.toLowerCase()],
    ['asc']
  ),
}
